var common = require("../utiles/common")

module.exports = {
    register: function () {
        document.createElement('avatar')
        ko.components.register('avatar', {
            viewModel: function (params) {
                var $this = this;
                if ($this.url) {
                    $this.type = "img"
                } else {
                    $this.type = params.type;
                }

                $this.size = params.size;

                if ($this.type === "img") {
                    $this.url = params.url;
                } else {
                    $this.color = params.color ? params.color : common.randomColor(params.name);
                    $this.name = params.name.charAt(0) + "";
                }
            },
            template: require("./Avatar.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/Avatar.js
// module id = 87
// module chunks = 0